module.exports = __webpack_public_path__ + "img/icon-backup.7d59e256.svg";